import React from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import {
  Button,
  FieldLabel,
  Font,
  Label,
} from "@moneyforward/mfx_biz_react_components";

type Props = {
  email: string;
  onClick: () => void;
  loading: boolean;
  editable: boolean;
  disableRequiredLabel?: boolean;
};

export const EmailBlock = ({
  email,
  onClick,
  loading,
  editable,
  disableRequiredLabel = false,
}: Props) => {
  const isSpMode = useIsSpMode();

  if (!email) {
    return <></>;
  }

  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        {editable && !disableRequiredLabel ? (
          <FieldLabel isRequired>メールアドレス</FieldLabel>
        ) : (
          <Font variant="m" component="p">
            メールアドレス
          </Font>
        )}
      </div>
      <div css={inputWrapper}>
        <Font variant="m" component="span" css={authorityName}>
          {email}
        </Font>
        {editable && (
          <Button
            type="button"
            variant="secondary"
            onClick={onClick}
            disabled={loading}
          >
            変更
          </Button>
        )}
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  flex: 1,
  alignItems: "center",
});

const authorityName = css({
  marginRight: "10px",
});
